import * as React from 'react';
import { isEmpty } from 'lodash';
import { ConfigContext } from 'modules/context';
import {
    ITEMS_DISPLAY_FLOW_STEP,
    ITEMS_DISPLAY_SELECT_ACTION,
    TEXT_KEYS
} from './items-display-page.constants';
import { getAlignmentClass } from './items-display-page.utils';
import { translate } from 'components/translate-hoc';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import { IItemsDisplayPageProps } from './items-display-page.types';
import { IContentPackItem } from '@sitegen/common/types';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import './items-display-page.styles.less';

class ItemsDisplayPage extends React.PureComponent<IItemsDisplayPageProps>  {
    public componentDidMount() {
        AnalyticsService.sendFlowEvent({
            ...ITEMS_DISPLAY_FLOW_STEP,
            action: ITEMS_DISPLAY_FLOW_STEP.flowStep,
            category: CATEGORY.DISPLAY
        });
    }

    private onItemSelect = (contentPackItem: IContentPackItem): void => {
        const { alreadyOwned, actionIds, packId } = contentPackItem;
        if (!alreadyOwned && !isEmpty(actionIds)) {
            this.props.selectGameItem(actionIds![0]);
            AnalyticsService.sendFlowEvent({
                ...ITEMS_DISPLAY_FLOW_STEP,
                action: ITEMS_DISPLAY_SELECT_ACTION(packId),
                category: CATEGORY.INTERACTION
            });
        }
    };

    public render(): JSX.Element {
        const {
            contentGameItems,
            dangerouslyTranslateWithHTML: translateKey
        } = this.props;
        const { getModeClass } = this.context;
        return (
            <div className={getModeClass('sitegen-redeem-items-display-page')}>
                <div className="sitegen-redeem-items-display-page__content">
                    <div className="sitegen-redeem-items-display-page__content-title">
                        {translateKey(TEXT_KEYS.REDEEM_ITEM_TITLE)}
                    </div>
                    <div className={`sitegen-redeem-items-display-page__items-block ${getAlignmentClass(contentGameItems.length)}`}>
                        {contentGameItems.map(({ imageSrc, packId, actionIds, edition, alreadyOwned }: IContentPackItem) => (
                            <div
                                key={packId}
                                onClick={() => this.onItemSelect({ alreadyOwned, actionIds, packId })}
                                className={
                                    `sitegen-redeem-items-display-page__items-block__game-block ${alreadyOwned && 'show-message'}`
                                }
                            >
                                <div className="sitegen-redeem-items-display-page__items-block__edition-type">
                                    {edition}
                                </div>
                                <div className="sitegen-redeem-items-display-page__items-block__image-block">
                                    <img
                                        src={imageSrc as string}
                                        alt=""
                                    />
                                    {alreadyOwned &&
                                    <div className="sitegen-redeem-items-display-page__items-block__not-available">
                                        {translateKey(TEXT_KEYS.REDEEM_ITEM_NOT_AVAILABLE)}
                                    </div>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

ItemsDisplayPage.contextType = ConfigContext;

export default translate()(ItemsDisplayPage);
